<template>
<div id="create-form">
  <user-form
  ></user-form>
</div>
</template>

<script>
import UserForm from '@/components/UserForm'

import UserStore from '@/stores/UserStore'

export default {
  data () {
    return UserStore.state
  },

  components: {
    'user-form': UserForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserCreate.vue